routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('index', {
      url: '/',
      template: require('./index.html'),
      controller: 'AppController',
      controllerAs: 'index',
      data: {pageTitle: 'Welcome to CourtMeNow Christian Dating Service'},
      authRequired: true
    })
    .state('recover', {
      url: '/register/recover',
      template: require('./recoverPassword.html'),
      controller: 'AppController',
      controllerAs: 'recover',
      data: {pageTitle: 'Recover Password'},
      authRequired: true
    });
}



// WEBPACK FOOTER //
// ./src/app/features/index/routes.js